import { parsePhoneNumberWithError, parsePhoneNumberFromString } from "libphonenumber-js";

// Characters commonly added by manual typing or AsYouType formatting
const FORMATTING_CHARACTERS = /[\s().-]/g;
// After removing formatting, only digits with at most one leading "+" are allowed
const PHONE_CHARACTERS = /^\+?\d+$/;

/**
 *
 * @param {string} value
 * @param {*} countryCode
 * @returns
 */
const validatePhone = (value, countryCode = "") => {
  const errorMessage = "error_phone_number_correct";
  if (typeof value !== "string") return errorMessage;

  const normalizedValue = value.replace(FORMATTING_CHARACTERS, "");
  if (!PHONE_CHARACTERS.test(normalizedValue)) return errorMessage;

  try {
    let isValid = null;
    if (countryCode) {
      isValid = parsePhoneNumberWithError(normalizedValue, countryCode).isValid();
    } else {
      const phone = parsePhoneNumberFromString(normalizedValue);
      if (!phone) return errorMessage;
      isValid = phone.isValid();
    }

    return isValid || errorMessage;
  } catch (error) {
    return errorMessage;
  }
};

/**
 * Converts a phone value to canonical E.164 ("+971525587878").
 * Falls back to the trimmed original value when it cannot be parsed.
 *
 * @param {string} value
 * @returns {string}
 */
export const normalizePhone = (value) => {
  if (typeof value !== "string") return "";

  const trimmedValue = value.trim();
  const normalizedValue = trimmedValue.replace(FORMATTING_CHARACTERS, "");

  try {
    const phone = parsePhoneNumberFromString(normalizedValue);
    return phone ? phone.number : trimmedValue;
  } catch (error) {
    return trimmedValue;
  }
};

export default validatePhone;
